import { call, put, takeLatest } from "redux-saga/effects";
import {
  SG_GET_SURVEY_INVITES,
  GET_SURVEY_INVITES,
  SG_FETCH_SURVEY_INVITE,
  FETCH_SURVEY_INVITE,
  SG_ADD_SURVEY_INVITE,
  ADD_SURVEY_INVITE,
  SG_UPDATE_SURVEY_INVITE,
  UPDATE_SURVEY_INVITE,
  SG_DELETE_SURVEY_INVITE,
  DELETE_SURVEY_INVITE,
  SURVEY_INVITES_PENDING,
  ALL_ERRORS,
} from "constants/actions";
import * as api from "constants/api";

function* getSurveyInvites(action) {
  try {
    yield put({ type: SURVEY_INVITES_PENDING });
    const response = yield call(api.GET_SURVEY_INVITES, action.payload);
    yield put({ type: GET_SURVEY_INVITES, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* fetchSurveyInvite(action) {
  try {
    yield put({ type: SURVEY_INVITES_PENDING });
    const response = yield call(api.FETCH_SURVEY_INVITE, action.payload);
    yield put({ type: FETCH_SURVEY_INVITE, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* addSurveyInvite(action) {
  try {
    yield put({ type: SURVEY_INVITES_PENDING });
    const response = yield call(api.ADD_SURVEY_INVITE, action.payload);
    yield put({ type: ADD_SURVEY_INVITE, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* updateSurveyInvite(action) {
  try {
    yield put({ type: SURVEY_INVITES_PENDING });
    const response = yield call(api.UPDATE_SURVEY_INVITE, action.payload);
    yield put({ type: UPDATE_SURVEY_INVITE, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* deleteSurveyInvite(action) {
  try {
    yield put({ type: SURVEY_INVITES_PENDING });
    yield call(api.DELETE_SURVEY_INVITE, action.payload);
    yield put({ type: DELETE_SURVEY_INVITE, payload: action.payload });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export default function* surveyInvitesSaga() {
  yield takeLatest(SG_GET_SURVEY_INVITES, getSurveyInvites);
  yield takeLatest(SG_FETCH_SURVEY_INVITE, fetchSurveyInvite);
  yield takeLatest(SG_ADD_SURVEY_INVITE, addSurveyInvite);
  yield takeLatest(SG_UPDATE_SURVEY_INVITE, updateSurveyInvite);
  yield takeLatest(SG_DELETE_SURVEY_INVITE, deleteSurveyInvite);
}